import { useSelector } from 'react-redux';
import SimpleBar from 'simplebar-react';

import { PageWithSettingsComponent, SimpleTitle } from 'shared/components/page-with-settings';
import { LoadingComponent } from 'shared/components/loading';
import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';

import { ScreenerStore } from '../redux/model';
import { ScreenerSettingsContentComponent } from './ScreenerSettingsContentComponent';
import { ScreenerSettingsActionsComponent } from './ScreenerSettingsActionsComponent';
import { ScreenerHeaderComponent } from './ScreenerHeaderComponent';
import { ScreenerTableComponent } from './ScreenerTableComponent';

import styles from './ScreenerLayoutComponent.module.scss';
import { AdsComponent } from 'shared/components/ads';
import { useContext } from 'react';
import { SiteResolutionContext, decodeSiteResolutionFunc, decodeSiteResolutionValue } from 'shared/mechanics/site-resolution';

const ContentComponent = () => {
	const siteResolution = useContext(SiteResolutionContext);

	const adsBefore = decodeSiteResolutionFunc(
		siteResolution,
		() => null,
		() => <AdsComponent id="screener:mobile" isVertical={false} />);

	const adsAfter = decodeSiteResolutionFunc(
		siteResolution,
		() => <AdsComponent id="screener:desktop" isVertical={true} />,
		() => null);

	const flexDirection = decodeSiteResolutionValue(
		siteResolution,
		"flex-direction-row",
		"flex-direction-column");

	return (
		<div className={styles.container}>
			<div className="flex-size-least">
				{ adsBefore }
			</div>
			<ScreenerHeaderComponent className={styles.header} />
			<div className={`display-flex ${flexDirection}`}>
				<SimpleBar className={styles.table}>
					<ScreenerTableComponent />
				</SimpleBar>
				<div className="flex-size-least">
					{ adsAfter }
				</div>
			</div>
		</div>
	);
}

export const ScreenerLayoutComponent = () => {
	const isDataLoaded = useSelector<ScreenerStore>(x => x.data.isLoaded);

	return (
		<SiteLayoutComponent activeSection={SiteSection.Screener}>
			{renderInnerContent()}
		</SiteLayoutComponent>
	);

	function renderInnerContent() {
		if (!isDataLoaded)
			return <LoadingComponent />;

		return (
			<PageWithSettingsComponent
				defaultIsSettingsExpanded={true}
				contentChild={<ContentComponent />}
				settingsContentChild={<ScreenerSettingsContentComponent />}
				settingsActionsChild={<ScreenerSettingsActionsComponent />}

				settingsTitleChild={props => <SimpleTitle {...props} text="Настройки фильтров" />}
				settingCompactModeShowButtonText="Настройки фильтров"/>
		);
	}
}